import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import { Chip, Container, Drawer, InputBase, Link, Stack, Switch, TableHead, TableSortLabel, Tooltip } from '@mui/material';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import SearchIcon from '@mui/icons-material/Search'
import AddNewRole from './addNewRole'
import ViewRoles from './viewRole'
import { useEffect, useState } from 'react'
import EditRole from './editRole'
import {
  masterRoleDeleteApi,
  masterRoleListApi,
} from '../../../api/master/masterAPI'
import jwt_decode from 'jwt-decode'
import SkeletonTableLoader from '../../../common/components/loaders/skeletonLoader'
import { useLocation, useSearchParams } from 'react-router-dom'
import LoadingSection from '../../../common/components/loaders/loader'
import ConfirmationModal from '../../../common/components/custom/modal/modal'
import NoDataFoundCard from '../../../common/components/cards/noDataFoundCard'
import { createRef } from 'react'
import { setRolesList } from '../../../store/slice/userManagementSlice'
import {
  checkPermission,
  getCompanyLevel,
  getComparator,
  normalizeApiResponse,
  stableSort,
} from '../../../helpers/HelperFunctions'
import { PERMISSIONS } from '../../../helpers/Constants'
import { styled } from '@mui/system'
import { Add as AddIcon } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel'
import DrawerHeader from '../../../common/components/drawer/DrawerHeader'
import ThemeButton from '../../../common/components/button/Button'
import { useToastContext } from '../../../App'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import { useUserManagementRedux } from '../UserManagement'
import FilterListIcon from '@mui/icons-material/FilterList';
import useTableFilters from '../../../common/components/tableFilter/useTableFilters'
import GlobalSearch from '../../../common/components/tableFilter/GlobalSearch'
import ColumnFilter from '../../../common/components/tableFilter/ColumnFilter'
// ──────────────────────────────────────────────────────────────
// Table Column configuration
// ──────────────────────────────────────────────────────────────
const tableColumns = [
  { key: 'roleName', label: 'Role Name' },
]
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

function RoleTable(props) {
  const { state: commonState } = useCommonRedux();
  const { dispatch, state: _state } = useUserManagementRedux()
  const { toast } = useToastContext();
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)
  const [rowsList, setRowsList] = React.useState([])
  const [edited, setEdited] = React.useState('')
  const [details, setDetails] = React.useState('')
  const [loader, setLoader] = React.useState(false)
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - rowsList?.length)
      : 0
  const pageTopRef = createRef()
  const [isOpen, setIsOpen] = useState(false)

  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState()
  const {
    searchTerm,
    setSearchTerm,
    filteredData,
    uniqueValues,
    filterAnchorEl,
    setFilterAnchorEl,
    currentColumn,
    openFilter,
    closeFilter,
    toggleFilter,
    clearColumnFilter,
    isFilterActive,
    filters,
  } = useTableFilters(rowsList, tableColumns);
  const currentLabel = tableColumns.find((c) => c.key === currentColumn)?.label || currentColumn || '';
  const sortedRows = React.useMemo(() => {
    return stableSort(filteredData, getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
  }
  let inputHandler = (e) => {
    const lowerCase = e.target.value.toLowerCase()
    const filteredData = _state.rolesList.filter((el) => {
      if (lowerCase === '') {
        return el
      } else {
        return el?.roleName.toLowerCase().includes(lowerCase)
      }
    })
    setRowsList(filteredData)
    setPage(0)
  }
  const handleClose = () => {
    setIsOpen(false)
  }
  const handleDelete = (id) => {
    setSubmitLoader(true)
    masterRoleDeleteApi(
      id,
      getCompanyLevel(
        searchParams.get('company_id'),
        location.pathname.slice(1)
      )
    )
      .then((response) => {
        setSubmitLoader(false)
        toast.showToast(response.data.message, 'success')
        getDecodeValue()
        handleClose()
        toggleDrawer('right', false)
      })
      .catch((error) => {
        setSubmitLoader(false)
        toast.showToast(normalizeApiResponse(error)?.message, 'error')
      })
  }
  const getRoleList = (id) => {
    setLoader(true)
    masterRoleListApi(
      id,
      getCompanyLevel(
        searchParams.get('company_id'),
        location.pathname.slice(1)
      )
    )
      .then((response) => {
        setLoader(false)
        const sortedData = [...response.data.result].sort((a, b) =>
          a.roleName.localeCompare(b.roleName)
        )
        dispatch(setRolesList(sortedData))
        setRowsList(sortedData)
      })
      .catch((error) => {
        setLoader(false)
        toast.showToast(normalizeApiResponse(error)?.message, 'error')
      })
  }
  const getDecodeValue = () => {
    const decodeToken = localStorage.getItem('sd_cp.jwt:tkn')
    const decoded = jwt_decode(decodeToken)
    if (decoded) {
      let companyId = searchParams.get('company_id')
      if (!companyId) {
        companyId = decoded?.company_id
      }
      getRoleList(companyId)
    }
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    pageTopRef.current.scrollTop = 0
  }
  const gotoDrawer = (event) => {
    setEdited(event)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(0)
    pageTopRef.current.scrollTop = 0
  }

  const [state, setState] = React.useState({
    right: false,
  })

  const toggleDrawer = (anchor, open, switchVal, details, load) => {
    if (load) {
      getDecodeValue()
    }
    setDetails(details)
    setEdited(switchVal)
    setState({ ...state, [anchor]: open })
  }

  useEffect(() => {
    getDecodeValue()
  }, [])

  const checkAddEdit = (item, index) => {
    switch (item) {
      case 'add':
        return <AddNewRole toggleDrawer={toggleDrawer} />
      case 'view':
        return (
          <>
            <ViewRoles details={details} gotoDrawer={gotoDrawer}></ViewRoles>
          </>
        )
      case 'edit':
        return (
          <>
            <EditRole
              toggleDrawer={toggleDrawer}
              details={details}
              gotoDrawer={gotoDrawer}
            ></EditRole>
          </>
        )
    }
  }
  const canEditRole = checkPermission(
    [
      PERMISSIONS.masterRoleUpdate,
      PERMISSIONS.serviceproviderRoleUpdate,
      PERMISSIONS.resellerRoleUpdate,
      PERMISSIONS.customerRoleUpdate,
    ],
    commonState.currentCompanyDetails
  )

  const canDeleteRole = checkPermission(
    [
      PERMISSIONS.masterRoleDelete,
      PERMISSIONS.serviceproviderRoleDelete,
      PERMISSIONS.resellerRoleDelete,
      PERMISSIONS.customerRoleDelete,
    ],
    commonState.currentCompanyDetails
  )

  const canAddRole = checkPermission(
    [
      PERMISSIONS.masterRoleCreate,
      PERMISSIONS.serviceproviderRoleCreate,
      PERMISSIONS.resellerRoleCreate,
      PERMISSIONS.customerRoleCreate,
    ],
    commonState.currentCompanyDetails
  )
  const renderDrawerHeader = () => {
    if (edited == 'view') {
      return (
        <h3 style={{ display: 'flex', marginTop: '-5px', marginBottom: '0' }}>
          <div>
            <h3 style={{ display: 'flex', margin: '10px 0 0 10px' }}>Role Details</h3>
            {canDeleteRole && (
              <div style={{ display: 'flex' }}>
                <div
                  style={{ fontSize: '15px', color: '#000000a1', cursor: 'pointer' }}
                  onClick={() => setIsOpen(true)}
                >
                  <PersonRemoveIcon
                    style={{
                      fontSize: '12px',
                      verticalAlign: 'middle',
                      margin: '0 5px 0 15px',
                    }}
                  />
                  Delete Role
                </div>
              </div>
            )}
          </div>
        </h3>
      )
    }
    if (edited == 'edit') {
      return (
        <h3 style={{ display: 'flex', marginTop: '-5px', marginBottom: '0' }}>
          <div style={{ marginLeft: '10px' }}>
            Update Role
            <div style={{ display: 'flex' }}>
              <div style={{ fontSize: '15px', color: '#000000a1' }}>
                Assign roles and permission
              </div>
            </div>
          </div>
        </h3>
      )
    }
    if (edited == 'add') {
      return (
        <DrawerHeader
          header="Add Roles & Permissions"
          onClick={() => toggleDrawer('right', false)}
        />
      )
    }
    return null
  }

  const renderBackAndCloseButtons = () => (
    <div>
      {canEditRole && edited === 'edit' && (
        <Tooltip title="Back">
          <IconButton
            aria-label="back"
            onClick={() => gotoDrawer('view')}
            style={{ marginLeft: '-2px', float: 'left', borderRadius: 0 }}
          >
            <KeyboardBackspaceIcon />
          </IconButton>
        </Tooltip>
      )}
      {edited !== 'add' && (
        <Tooltip title="Close">
          <IconButton
            aria-label="close"
            onClick={() => toggleDrawer('right', false)}
            style={{ float: 'right', borderRadius: 0 }}
          >
            <CancelIcon color="error" size="large" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  )

  return (
    <Container maxWidth="xl">
      {submitLoader && <LoadingSection />}

      <React.Fragment>
        <Drawer
          PaperProps={{ sx: { width: '25%' } }}
          variant="persistent"
          hideBackdrop
          anchor="right"
          open={state['right']}
        >
          {renderBackAndCloseButtons()}
          {renderDrawerHeader()}
          {checkAddEdit(edited)}

          <ConfirmationModal
            handleConfirm={() => handleDelete(details?.roleId)}
            title="Delete Role Confirmation"
            content={
              <span>
                Are you sure you want to delete this role <b>{details?.roleName}</b>?
              </span>
            }
            isOpen={isOpen}
            handleClose={handleClose}
          />
        </Drawer>
      </React.Fragment>

      {/* Search + Add Role section */}
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '0.5em',
          marginTop: '0.5em',
        }}
      >
        <GlobalSearch
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          placeholder="Search Roles"
        />

        {canAddRole && (
          <Tooltip title="Add New Role">
            <ThemeButton
              text="Add New Role"
              variant="contained"
              size="medium"
              sx={{ height: '32px', mt: 2 }}
              startIcon={<AddIcon />}
              onClick={() => toggleDrawer('right', true, 'add')}
            />
          </Tooltip>
        )}
      </Box>

      {/* Table Section */}
      <TableContainer
        sx={{
          height:
            rowsPerPage == 5 || rowsList?.length <= 7
              ? 'max-content'
              : 'calc(95vh - 200px)',
        }}
        component={Paper}
        ref={pageTopRef}
      >
        <Table stickyHeader sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead className="thead">
            <TableRow>
              <TableCell width="10px">S.No.</TableCell>
              {tableColumns.map((col) => (
                <TableCell key={col.key}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <TableSortLabel
                      active={orderBy === col.key}
                      direction={orderBy === col.key ? order : 'asc'}
                    // onClick={(e) => handleRequestSort(e, col.key)}
                    >{col.label}</TableSortLabel>
                    <IconButton
                      size="small"
                      onClick={(e) => openFilter(e, col.key)}
                      color={isFilterActive(col.key) ? 'primary' : 'default'}
                    >
                      <FilterListIcon fontSize="small" />
                    </IconButton>
                    {isFilterActive(col.key) && (
                      <Chip size="small"
                        label={(filters?.[col.key]?.length || 0)}
                        //  label={filters[col.key]?.length  || 0} 
                        color="primary" />
                    )}
                  </Box>
                </TableCell>
              ))}
              {/* <TableCell>Role Name</TableCell> */}
            </TableRow>
          </TableHead>

          <TableBody className="tbody">
            {
              loader ? (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6}>
                    <SkeletonTableLoader />
                  </TableCell>
                </TableRow>
              )
                : (
                  <>
                    {(rowsPerPage > 0
                      ? filteredData?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : filteredData
                    )?.map((row, index) => (
                      <TableRow key={row?.roleName}>
                        <TableCell>{page * rowsPerPage + (index + 1)}</TableCell>
                        <TableCell
                          scope="row"
                          onClick={() => toggleDrawer('right', true, 'view', row)}
                        >
                          <Link>{row?.roleName}</Link>
                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}

                    {filteredData?.length === 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} style={{ border: 'none' }}>
                          <h3>
                            <NoDataFoundCard
                              messages="No Such Roles Found"
                              borderNone={true}
                            />
                          </h3>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      <Stack direction="row" justifyContent="space-between">
        {!loader && (
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-start', px: 2 }}>
            <Chip
              label={
                <>
                  <strong>{filteredData.length}</strong> / {rowsList.length} records
                </>
              }
              color={filteredData.length < rowsList.length ? 'primary' : 'default'}
              variant="outlined"
              size="small"
            />
            {(filters && Object.keys(filters).length > 0 || searchTerm.trim()) && (
              <Chip
                label="Filtered"
                color="secondary"
                size="small"
                sx={{ ml: 1 }}
              />
            )}
          </Box>
        )}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
          component="div"
          count={filteredData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Stack>
      <ColumnFilter
        anchorEl={filterAnchorEl}
        onClose={closeFilter}
        columnLabel={currentLabel}
        uniqueValues={uniqueValues[currentColumn] || []}
        selectedValues={filters ? filters[currentColumn] : []}
        onToggleValue={toggleFilter}
        onClear={clearColumnFilter}
      />
    </Container >
  )
}

export default RoleTable
